React = require 'react'
$ = require 'jquery'
Auth = require 'db/auth'
ClosedBoardsView = require 'views/archive/closed-boards-view'
Controller = require 'controller'
CreateBoardComponent = require 'views/board-create/create-board-component'
Dialog = require 'views/lib/dialog'
ModelLoader = require 'db/model-loader'
SidebarState = require 'view-models/sidebar-state'
{ maybeDisplayMemberLimitsError } = require 'views/board-menu/member-limits-error'
Util = require 'lib/util'
View = require 'view'
template = require 'views/templates/boards_sidebar_boards_buttons'
track = require 'debug/track'

module.exports = class BoardsSidebarBoardsButtonsView extends View
  initialize: ->
    @listenTo SidebarState, 'change:pinBoardsListSidebar', ->
      @updatePinned()

  events:
    'click .js-add-board': 'addBoard'
    'click .js-pin': 'pinDrawer'
    'click .js-unpin': 'unpinDrawer'
    'click .js-open-closed-boards': 'openClosedBoards'

  renderOnce: ->
    @$el.html template()

    @updatePinned()

    @

  addBoard: (e) ->
    Util.stop(e)

    track("Boards Drawer", "Add Board")

    if maybeDisplayMemberLimitsError($(e.target), null, Auth.me())
      return

    Dialog.show
      displayType: 'mod-no-chrome'
      opacity: 0.75
      reactElement: React.createElement CreateBoardComponent,
        defaultOrg: Controller.getCurrentOrganization()
        trackingOpts: { category: 'boards menu', method: 'by clicking create new board in boards menu' }

    return

  unpinDrawer: ->
    track("Boards Drawer", "Unpin Drawer")
    SidebarState.hidePinSidebar()

  pinDrawer: ->
    track("Boards Drawer", "Pin Drawer")
    SidebarState.showPinSidebar()

  updatePinned: ->
    @$('.js-pin').toggleClass('hide', SidebarState.getPinSidebar())
    @$('.js-unpin').toggleClass('hide', !SidebarState.getPinSidebar())

  openClosedBoards: (e) ->
    Util.stop(e)

    SidebarState.hideSidebar()

    Dialog.show
      view: new ClosedBoardsView({ model: Auth.me(), @modelCache })

    ModelLoader.loadClosedBoards().done()

    track("Boards Drawer", "Open Closed Boards")

    return



// WEBPACK FOOTER //
// ./app/scripts/views/boards-sidebar/boards-sidebar-boards-buttons-view.coffee